import makeUrlSearchParams from './makeUrlSearchParams';

export default function makeUrl(baseUrl, path, options = {}) {
  return baseUrl + path + makeUrlSearchParams(options.urlSearchParams);
}
